import React from "react";
import styles from "./advisorIcon.module.scss";

export const ADVISOR_ICON_SRC = "/assets/pivony-advisor-icon.png";

const SIZE_CLASS = {
  xs: styles.sizeXs,
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
};

const AdvisorIcon = ({ className = "", size = "md", alt = "", ...rest }) => (
  <img
    src={ADVISOR_ICON_SRC}
    alt={alt}
    className={`${styles.advisorIcon} ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`.trim()}
    aria-hidden={alt ? undefined : true}
    draggable={false}
    {...rest}
  />
);

export default AdvisorIcon;
